<template>
  <section id="app-of-the-day" class="bg-dark-blue">
    <div class="section-inner">
      <div class="container">
        <div class="copy">
          <img class="app-of-the-day" src="./images/app-of-the-day-white.svg" alt="">
          <p>"RememBear is a password manager - but with bear puns. As in, ensuring you have the bear minimum of work to do in remembering your passwords, while keeping them ultra-safe. What’s not to&nbsp;love?"</p>
          <p class="small-copy">App Store feature</p>
        </div>
        <img class="app-store" :srcset="require('./images/app-store-phone.png') + ' 1x,' + require('./images/app-store-phone@2x.png') + ' 2x'" src="./images/app-store-phone@2x.png" alt="">
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'app-of-the-day',
  data () {
    return {}
  },
  methods: {}
}
</script>

<style scoped lang="stylus" src="./app-of-the-day.styl" >



// WEBPACK FOOTER //
// src/components/app-of-the-day/app-of-the-day.vue